import { CognitoUserPool } from 'amazon-cognito-identity-js';

const userPoolKey = "us-east-1_xjLsCuMIn";
const clientIdKey = "hm1iamd49c228o1v5nt732r9m";

const poolData = new CognitoUserPool({
  UserPoolId: userPoolKey,
  ClientId: clientIdKey
});

export default poolData;